import { Component } from "@angular/core";
import { DevextremesharedmoduleModule } from "../../../../../shared/Module/devextremeshared/devextremeshared.module";
import { CancelbuttonComponent } from "../../../../../shared/components/cancelbutton/cancelbutton.component";
import {
  DomainEnums,
  Month,
  OperationalModes,
} from "../../../../../classes/infrastructure/enums";
import { UIUtils } from "../../../../../services/uiutils.service";
import { Router } from "@angular/router";
import { AppStateManageService } from "../../../../../services/app-state-manage.service";
import { Utils } from "../../../../../services/utils.service";
import notify from "devextreme/ui/notify";
import { MonthYearInitService } from "../../../../../services/finantial-year-wise-months.service";
import { NavItem_Entity_Authority } from "../../../../../shared/components/side-navigation-menu/side-navigation-menu.component";
import { SidebarMenuStateService } from "../../../../../services/sidebarmenustateservice";
import { FileTransferObject } from "../../../../../classes/infrastructure/filetransferobject";
import { BaseUrlService } from "../../../../../services/baseurl.service";
import { TrainingVideo } from "../../../../../classes/domain/entities/website/masters/landing-page/training-video/trainingvideo";
import { SUBMENU_ID } from "../../../../../classes/domain/constants";

@Component({
  selector: 'app-training-video-master-details',
  templateUrl: './training-video-master-details.component.html',
  styleUrl: './training-video-master-details.component.scss',
  standalone: true,
  imports: [DevextremesharedmoduleModule, CancelbuttonComponent],
})
export class TrainingVideoMasterDetailsComponent {
  Entity: TrainingVideo = TrainingVideo.CreateNewInstance();
  isSaveDisabled: boolean = false;
  IsNewEntity: boolean = true;
  InitialEntity: TrainingVideo = null as any;
  DetailsFormTitle:
    | "Add Training Video Master"
    | "Edit Training Video Master" = "Add Training Video Master";
  isChecked: boolean = false;
  MasterList: TrainingVideo[] = [];

  MonthList = DomainEnums.MonthList(true, "Select Month");
  ContraceptivePillsTypesList = DomainEnums.ContraceptivePillsTypeList(
    true,
    "Select",
  );

  // Financial Year related
  currentMonth: number = 0;
  PreviousMonth: number = 0;
  CurrentFinancialYear: string = "";
  March = Month.March;
  April = Month.April;
  YearsList: { Ref: number; Name: string }[] = [];
  isApril: boolean = false;

  LoginRole: number = 0;

  EntityType: string = "Training_Video_Master";
  EntityAuthority: NavItem_Entity_Authority | undefined = undefined;
  CanAddOrEdit: boolean = false;
  IsReadOnlyMode: boolean = false;
  isEditMode: boolean = false;
  operationMode: OperationalModes = OperationalModes.CanAdd;
  IsViewMode: boolean = false;

  DeletedDocumentPaths: string[] = []; // optional (if backend supports delete)
  MAX_PHOTOS = 1;
  LoginToken: string = '';

  constructor(
    private uiUtils: UIUtils,
    private router: Router,
    private appStateManage: AppStateManageService,
    private utils: Utils,
    private monthYearService: MonthYearInitService,
    private sidebarMenuState: SidebarMenuStateService,
    private baseUrl: BaseUrlService,

  ) {
    const navigation = this.router.getCurrentNavigation();
    const fromMaster = navigation?.extras?.state?.["fromMaster"];

    if (!fromMaster) {
      this.router.navigate(["/"]);
      return;
    }
    this.operationMode =
      navigation?.extras?.state?.["mode"] ?? OperationalModes.CanAdd;

    this.IsNewEntity = this.operationMode === OperationalModes.CanAdd;
    this.IsViewMode = this.operationMode === OperationalModes.CanView;
    this.isEditMode = this.operationMode === OperationalModes.CanEdit;
  }

  async ngOnInit() {
    this.LoginToken = this.appStateManage.getLoginToken();
    this.sidebarMenuState.menu$.subscribe((menu) => {
      let SideBarMenuItemList = menu;
      this.EntityAuthority = SideBarMenuItemList.find(
        (e) => e.MenuId == this.EntityType,
      );
      this.applyPermission();
    });

    // Allow access only when coming from table; refresh or direct URL is blocked
    if (!sessionStorage.getItem("fromTable")) {
      this.router.navigate([SUBMENU_ID.TRAINING_VIDEO_MASTER]);
      return;
    }
    sessionStorage.removeItem("fromTable"); // Clear flag so refresh on details page redirects back to table

    const stored = this.appStateManage.StorageKey.getItem(
      "FinancialYearResponses",
    );
    const financialYearResponses = stored ? JSON.parse(stored) : [];
    if (financialYearResponses.length > 0) {
      this.CurrentFinancialYear = financialYearResponses[0].financial_year_id;
    } else {
      this.YearsList = financialYearResponses;
      this.isApril = true;
    }

    this.isEditMode =
      this.appStateManage.StorageKey.getItem("Editable") == "Edit";
    // ✅ SECOND: Load hierarchy data

    // ✅ THIRD: Apply appropriate filters based on mode
    if (this.isEditMode) {
      this.IsNewEntity = false;
      this.DetailsFormTitle = this.IsNewEntity
        ? "Add Training Video Master"
        : "Edit Training Video Master";
      this.Entity = TrainingVideo.GetCurrentInstance();
      this.appStateManage.StorageKey.removeItem("Editable");
    } else {
      // ➕ ADD MODE
      this.IsNewEntity = true;
      this.DetailsFormTitle = "Add Training Video Master";

      // ✅ Service already has the current filter state from table
      // Just patch it into entity
    }
    this.applyPermission();

    this.InitialEntity = Object.assign(
      TrainingVideo.CreateNewInstance(),
      this.utils.DeepCopy(this.Entity),
    ) as TrainingVideo;
  }

  private applyPermission(): void {
    if (!this.EntityAuthority) {
      this.CanAddOrEdit = false;
      this.IsReadOnlyMode = true;
      return;
    }
    switch (this.operationMode) {
      case OperationalModes.CanView:
        this.CanAddOrEdit = false;
        this.IsReadOnlyMode = true;
        break;

      case OperationalModes.CanAdd:
        this.CanAddOrEdit = this.EntityAuthority.CanAdd ?? false;
        this.IsReadOnlyMode = !this.CanAddOrEdit;
        break;

      case OperationalModes.CanEdit:
        this.CanAddOrEdit = this.EntityAuthority.CanEdit ?? false;
        this.IsReadOnlyMode = !this.CanAddOrEdit;
        break;

      default:
        this.CanAddOrEdit = false;
        this.IsReadOnlyMode = true;
        break;
    }
  }

  selectAllValue(event: MouseEvent): void {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  SaveTrainingVideo = async () => {
    this.Entity.p.created_by = this.appStateManage.getLoginUserRef();
    this.Entity.p.updated_by = this.appStateManage.getLoginUserRef();

    this.isSaveDisabled = true;
    let EntityToSave = this.Entity.GetEditableVersion();
    let entitiesToSave = [EntityToSave];

    let tr = await this.utils.SavePersistableEntities(entitiesToSave);
    console.log("EntityToSave :", EntityToSave);

    if (!tr.Successful) {
      this.isSaveDisabled = false;
      this.uiUtils.showErrorMessage("Error", tr.Message);
      return;
    }
    this.isSaveDisabled = false;

    if (this.IsNewEntity) {
      notify("Training Video Master saved successfully!", "success", 3000);
      this.Entity = TrainingVideo.CreateNewInstance();
      await this.router.navigate([SUBMENU_ID.TRAINING_VIDEO_MASTER]);
    } else {
      notify(
        "Training Video Master Updated successfully!",
        "success",
        3000,
      );
      this.Entity = TrainingVideo.CreateNewInstance();
      await this.router.navigate([SUBMENU_ID.TRAINING_VIDEO_MASTER]);
    }
  };

  async BackTrainingVideo() {
    // debugger
    if (this.isEditMode) {
      // for cancel if not access to edit
    }
    if (!this.utils.AreEqual(this.InitialEntity, this.Entity)) {
      await this.uiUtils.showConfirmationMessage(
        "Cancel",
        `This process is IRREVERSIBLE!
      <br/>
      Are you sure that you want to Cancel Training Video Master?`,
        async () => {
          await this.router.navigate([SUBMENU_ID.TRAINING_VIDEO_MASTER]);
        },
      );
    } else {
      await this.router.navigate([SUBMENU_ID.TRAINING_VIDEO_MASTER]);
    }
  }
}
